<template>
    <el-date-picker
        type="daterange"
        align="right"
        v-model="selectedDate"
        unlink-panels range-separator="-"
        start-placeholder="Od"
        end-placeholder="Do"
        :picker-options="pickerOptions"
        :class="pickerClass">
    </el-date-picker>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      value: {
        type: Array
      },
      pickerClass: {
          type: String
      }
    },
    data () {
      return {
        selectedDate: null,
        pickerOptions: {
          shortcuts: [{
            text: 'Miesiąc',
            onClick (picker) {
              const end = new Date()
              const start = moment().startOf('month')
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Kwartał',
            onClick (picker) {
              const end = new Date()
              const start = moment().startOf('quarter')
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Rok',
            onClick (picker) {
              const end = new Date()
              const start = moment().startOf('year')
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Wyczyść',
            onClick (picker) {
              picker.$emit('pick', null)
            }
          }]
        }
      }
    },
    created(){
      this.selectedDate = this.value;
    },
    watch:{
      value: function(){
        this.selectedDate = this.value;
      },
      selectedDate: function(){
        this.$emit('input', this.selectedDate)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// DateRangePicker.vue?70faa360